import AgentGroup from "@/views/ticket/components/agentGroup";
import { Simple as Agent } from "@/views/ticket//components/agent";
import { getTimezoneName } from "@/lib/format/time";
import { getTicketAgentData } from "../service";
import pageStyle from "./index.module.less";
import TimePicker from "@/components/timePicker";

export default {
    name: "AgentMonitor",
    components: { AgentGroup, Agent, TimePicker },
    data() {
        return {
            pageStyle,
            totalCount: 0,
            query: {
                group_id: null,
                agent_id: null,
                pageSize: 30,
                currentPage: 1,
                time: []
            },
            tableData: [],
            agentGroupMap: {}
        };
    },
    watch: {
        "$i18n.locale"() {
            this.getMonitorData();
        },
        query: {
            deep: true,
            handler() {
                this.getMonitorData();
            }
        }
    },
    methods: {
        async getMonitorData() {
            let time_zone = getTimezoneName();
            let { time, ...reset } = this.query;

            let { list, pagination } = await getTicketAgentData({
                ...reset,
                time_zone,
                end_time: Math.floor(time[1].getTime() / 1000),
                start_time: Math.floor(time[0].getTime() / 1000)
            });

            this.tableData = list;
            this.totalCount = pagination.totalCount;
        }
    }
};
